/**
 * Currency input helpers used across all financial forms.
 *
 * Accepts naturally-typed inputs ("5000", "5,000", "$5,000", "$5,000.50",
 * "  5000 ") and returns a clean numeric value for the backend.
 *
 * `formatMoney(value)` produces a display-friendly "$5,000.50" string.
 */

const CURRENCY_STRIP = /[^0-9.\-]/g;

/**
 * Parse a free-text currency input.
 * Returns NaN for inputs that contain no digits (caller decides how to handle).
 */
export const parseCurrency = (raw) => {
  if (raw === null || raw === undefined) return NaN;
  if (typeof raw === 'number') return raw;
  const cleaned = String(raw).replace(CURRENCY_STRIP, '').trim();
  if (cleaned === '' || cleaned === '-' || cleaned === '.') return NaN;
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : NaN;
};

export const formatMoney = (value, { withDecimals = false } = {}) => {
  const n = typeof value === 'number' ? value : parseCurrency(value);
  if (!Number.isFinite(n)) return '';
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: withDecimals ? 2 : 0,
    maximumFractionDigits: withDecimals ? 2 : 0,
  });
};
